import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import React from 'react';

import { StyledCardSwitchContainer, StyledContentContainer } from './Styles';

export interface CardSwitchProps {
    Icon: React.FC<any>;
    description: string;
    switchLabel: string;
    renderSwitch?: boolean;

    onChange?: (value: boolean) => void;
}
export function CardSwitch({
    Icon,
    description,
    switchLabel,
    renderSwitch,

    onChange,
}: CardSwitchProps) {
    return (
        <StyledCardSwitchContainer>
            <StyledContentContainer>
                <Icon style={{ alignSelf: 'center' }} />
                <Typography margin={0} variant="h5">
                    {description}
                </Typography>
            </StyledContentContainer>
            <StyledContentContainer>
                <Typography
                    margin={0}
                    style={{
                        color: '#999999',
                        marginTop: '6.5px',
                    }}
                    variant="h5"
                >
                    {switchLabel}
                </Typography>
                {renderSwitch && (
                    <Switch
                        inputProps={{ 'aria-label': 'controlled' }}
                        onChange={(event) => {
                            onChange?.(event.target.checked);
                        }}
                    />
                )}
            </StyledContentContainer>
        </StyledCardSwitchContainer>
    );
}

export default CardSwitch;
